<template>
    <div class="component">


        <div>
            <img src="/img/cover.jpg" width="100%">
        </div>

        <div class="container mt-5 mb-5" >
            <div class="d-flex justify-content-center row">
                <div class="col-md-9" >
                    <div id="carousel-1" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner" style="border: none;">
                            <div class="carousel-item active">
                                <div class="border rounded">
                                    <div class="row no-gutters">
                                        <div class="col-md-5">
                                            <video class="Add-Video" src="/img/Add-Video.mp4" controls autoplay style="width: 440px; margin-top: 20px;"></video>
                                        </div>
                                        <div class="col-md-7">
                                            <div class="bg-white p-2 px-3 testimonials">
                                                <p class="text-justify" style="padding-top: 30px; font-size: 14px;">I BRAND BD is a premium clothing Brand in Bangladesh that specializes in high-quality products and unmatched customer service. Our goal is to ensure the privacy and security of all our customers while providing them with a seamless shopping experience. All the officers of I BRAND BD are motivated to provide the best collections to the customers. For any queries and details,Call or Message us. I will always be ready to answer your questions.<br></p>
                                                <div class="d-flex justify-content-between stats border p-2">
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-danger">99%</span><span>Customer Care</span></div>
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-success">2147+</span><span>Happy Customer</span></div>
                                                </div>
                                                <div class="d-flex align-items-center mt-3 text-success font-weight-bold"><span class="mr-2" style="opacity: 0.5;">Contract</span><i class="fa fa-long-arrow-right" style="margin-top: 5px; padding-left: 10px;"></i> <a href="tel:+8801771-997014" style="margin-left: 10px; font-size: 12px;"><span>01771-997014</span></a> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="border rounded">
                                    <div class="row no-gutters">
                                        <div class="col-md-5"><img class="img-fluid profile" src="https://i.imgur.com/7YDXqMG.jpg" height="300"></div>
                                        <div class="col-md-7">
                                            <div class="bg-white p-2 px-3 testimonials">
                                                <p class="text-justify">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse.&nbsp;<br>Duis aute irure dolor in reprehenderit.<br></p>
                                                <div class="d-flex justify-content-between stats border p-2">
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-danger">80%</span><span>Services</span></div>
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-success">280+</span><span>Stores</span></div>
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-">200+</span><span>Cities</span></div>
                                                </div>
                                                <div class="d-flex align-items-center mt-3 text-success font-weight-bold"><span class="mr-2">Learn more</span><i class="fa fa-long-arrow-right"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="border rounded">
                                    <div class="row no-gutters">
                                        <div class="col-md-5"><img class="img-fluid profile" src="https://i.imgur.com/8s9FZSp.jpg" height="300"></div>
                                        <div class="col-md-7">
                                            <div class="bg-white p-2 px-3 testimonials">
                                                <p class="text-justify">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse.&nbsp;<br>Duis aute irure dolor in reprehenderit.<br></p>
                                                <div class="d-flex justify-content-between stats border p-2">
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-danger">50%</span><span>Services</span></div>
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-success">1800+</span><span>Stores</span></div>
                                                    <div class="d-flex flex-column align-items-center"><span class="font-weight-bold percentage text-">200+</span><span>Cities</span></div>
                                                </div>
                                                <div class="d-flex align-items-center mt-3 text-success font-weight-bold"><span class="mr-2">Learn more</span><i class="fa fa-long-arrow-right"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>





        <img id="ImgAdd3" src="/img/img-add-3.jpg" alt="">

<!-- NO:2 About: Future Product Card Start -->
        <div class="container mt-5 mb-5">
            <h2><b>Featured</b> Product's</h2>
            <div class="d-flex justify-content-center row">
                <div class="col-md-10">
                    <div class="row p-2 bg-white border rounded">
                        <div class="col-md-3 mt-1"><img class="img-fluid img-responsive rounded product-image" src="https://i.imgur.com/QpjAiHq.jpg"></div>
                        <div class="col-md-6 mt-1">
                            <h5>Quant olap shirts</h5>
                            <div class="d-flex flex-row">
                                <div class="ratings mr-2"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i></div><span>310</span>
                            </div>
                            <div class="mt-1 mb-1 spec-1"><span>Material composition:</span><span class="dot"></span><span>100% Cotton</span><span class="dot"></span><span> Best finish<br></span></div>
                            <div class="mt-1 mb-1 spec-1"><span>Care:</span><span class="dot"></span><span>wash with similar color, wash,</span><span class="dot"></span><span>do not bleach, and do not tumble dry.<br></span></div>
                            <p class="text-justify text-truncate para mb-0">Iron: iron at maximum of 110ºc/230ºf. by injected humour, or randomised words which don't look even slightly believable.<br><br></p>
                        </div>
                        <div class="align-items-center align-content-center col-md-3 border-left mt-1">
                            <div class="d-flex flex-row align-items-center">
                                <h4 class="mr-1">1300৳</h4><span class="strike-text">1800৳</span>
                            </div>
                            <h6 class="text-success">Free shipping</h6>
                            <div class="d-flex flex-column mt-4"><button style="background-color: #060606;" class="btn btn-block btn-sm" type="button"><a href="https://m.me/ibrand.bd.shop" style="color: #fff;">Details</a></button><button class="btn btn-outline-dark btn-sm mt-2" type="button">Coming Soon</button></div>
                        </div>
                    </div>
                    <div class="row p-2 bg-white border rounded mt-2">
                        <div class="col-md-3 mt-1"><img class="img-fluid img-responsive rounded product-image" src="https://i.imgur.com/JvPeqEF.jpg"></div>
                        <div class="col-md-6 mt-1">
                            <h5>Quant trident shirts</h5>
                            <div class="d-flex flex-row">
                                <div class="ratings mr-2"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i></div><span>295</span>
                            </div>
                            <div class="mt-1 mb-1 spec-1"><span>wear it with any dark or</span><span class="dot"></span><span>light-colored  formal</span><span class="dot"></span><span>or twill  pants.<br></span></div>
                            <div class="mt-1 mb-1 spec-1"><span>Unique design</span><span class="dot"></span><span>For men</span><span class="dot"></span><span>Casual<br></span></div>
                            <p class="text-justify text-truncate para mb-0">Product color may slightly vary, depending on your device's screen resolution<br><br></p>
                        </div>
                        <div class="align-items-center align-content-center col-md-3 border-left mt-1">
                            <div class="d-flex flex-row align-items-center">
                                <h4 class="mr-1">1600৳</h4><span class="strike-text">2200৳</span>
                            </div>
                            <h6 class="text-success">Free shipping</h6>
                            <div class="d-flex flex-column mt-4"><button style="background-color: #060606;" class="btn btn-dark btn-sm" type="button"><a href="https://m.me/ibrand.bd.shop" style="color: #fff;">Details</a></button><button class="btn btn-outline-dark btn-sm mt-2" type="button">Coming Soon</button></div>
                        </div>
                    </div>
                    <div class="row p-2 bg-white border rounded mt-2">
                        <div class="col-md-3 mt-1"><img class="img-fluid img-responsive rounded product-image" src="https://i.imgur.com/Bf4dIaN.jpg"></div>
                        <div class="col-md-6 mt-1">
                            <h5>Quant ruybi shirts</h5>
                            <div class="d-flex flex-row">
                                <div class="ratings mr-2"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i></div><span>123</span>
                            </div>
                            <div class="mt-1 mb-1 spec-1"><span>100% cotton</span><span class="dot"></span><span>Light weight</span><span class="dot"></span><span>Best finish<br></span></div>
                            <div class="mt-1 mb-1 spec-1"><span>Unique design</span><span class="dot"></span><span>For men</span><span class="dot"></span><span>Casual<br></span></div>
                            <p class="text-justify text-truncate para mb-0">Best Mens Casual Shirt Collection in Bangladesh - Infinity Mega Mall No comments yet! Add one to start the conversation.<br><br></p>
                        </div>
                        <div class="align-items-center align-content-center col-md-3 border-left mt-1">
                            <div class="d-flex flex-row align-items-center">
                                <h4 class="mr-1">900৳</h4><span class="strike-text">1100৳</span>
                            </div>
                            <h6 class="text-success">Free shipping</h6>
                            <div class="d-flex flex-column mt-4"><button style="background-color: #060606;" class="btn btn-dark btn-sm" type="button"><a href="https://m.me/ibrand.bd.shop" style="color: #fff;">Details</a></button><button class="btn btn-outline-dark btn-sm mt-2" type="button">Coming Soon</button></div>
                        </div>
                    </div>
                    <div class="row p-2 bg-white border rounded mt-2">
                        <div class="col-md-3 mt-1"><img class="img-fluid img-responsive rounded product-image" src="https://i.imgur.com/HO8e9b8.jpg"></div>
                        <div class="col-md-6 mt-1">
                            <h5>Quant tinor shirts</h5>
                            <div class="d-flex flex-row">
                                <div class="ratings mr-2"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i></div><span>110</span>
                            </div>
                            <div class="mt-1 mb-1 spec-1"><span>Adjustable cuffs with buttons</span><span class="dot"></span><span>Light weight</span><span class="dot"></span><span><br></span></div>
                            <div class="mt-1 mb-1 spec-1"><span>Unique design</span><span class="dot"></span><span>For men</span><span class="dot"></span><span>Casual<br></span></div>
                            <p class="text-justify text-truncate para mb-0">Men's Stylish Full Sleeve Casual Shirt by 10 seconds <br><br></p>
                        </div>
                        <div class="align-items-center align-content-center col-md-3 border-left mt-1">
                            <div class="d-flex flex-row align-items-center">
                                <h4 class="mr-1">1100৳</h4><span class="strike-text">1500৳</span>
                            </div>
                            <h6 class="text-success">Free shipping</h6>
                            <div class="d-flex flex-column mt-4"><button style="background-color: #060606;" class="btn btn-dark btn-sm" type="button"><a href="https://m.me/ibrand.bd.shop" style="color: #fff;">Details</a></button><button class="btn btn-outline-dark btn-sm mt-2" type="button">Coming Soon</button></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<!-- NO:2 About: Future Product Card End -->



<!-- NO:3 About: Image Add-1 Start -->


            <img id="ImgAdd" src="/img/img-add-1.jpg" alt="">


<!-- NO:3 About: Image Add-1 End -->



<!-- NO:4 About: Style-Video Start -->



            <video class="Style-Video" src="/img/ibrand-style.mp4" controls autoplay muted>
            </video>



<!-- NO:4 About: Style-Video End -->


<!-- NO:5 About: Image Add-2 Start -->


            <img id="ImgAdd2" src="/img/img-add-2.jpg" alt="">


<!-- NO:5 About: Image Add-2 End -->









<!-- NO:5 Happy Customer Start -->
    <div class="Happy">
         <div class="row">
            <div class="four col-md-3">
                <div class="box colored">
                    <i class="fa-solid fa-thumbs-up" style="color: #060606;"></i>
                    <span class="counter">2178+</span>
                    <p>Happy Customers</p>
                </div>
            </div>
            <div class="four col-md-3">
                <div class="box">
                    <i class="fa-solid fa-users" style="color: #060606;"></i>
                    <span class="counter">293+</span>
                    <p>Registered Members</p>
                </div>
            </div>
            <div class="four col-md-3">
                <div class="box">
                    <i class="fa  fa-shopping-cart"></i>
                    <span class="counter">4138+</span>
                    <p>Available Products</p>
                </div>
            </div>
            <div class="four col-md-3">
                <div class="box">
                    <i class="fa  fa-user"></i>
                    <span class="counter">602+</span>
                    <p>Saved Trees</p>
                </div>
            </div>
        </div>	
    </div>
<!-- NO:5 Happy Customer End -->



    </div>
</template>

<script>
    export default {
        name: 'AboutCompo'
    }
</script>

<style>
h2 {
	color: #212529;
	font-size: 26px;
	font-weight: 300;
	text-align: center;
	text-transform: uppercase;
	position: relative;
	margin: 30px 0 60px;
}
h2::after {
	content: "";
	width: 100px;
	position: absolute;
	margin: 0 auto;
	height: 4px;
	border-radius: 1px;
	background: #212529;
	left: 0;
	right: 0;
	bottom: -20px;
}

.Happy{
    margin-top:150px;
    margin-bottom: 150px;
}
.row{
    position: relative;
    margin-right: 0;
}

.box {
	display: block;
	background: #f6f6f6;
	padding: 40px 20px 37px;
	text-align: center
}

.box p {
	margin: 5px 0 0;
	padding: 0;
	color: #060606;
	font-size: 18px;
	font-weight: 500
}

.box i {
	font-size: 60px;
	margin: 0 0 15px;
	color: #060606
}

.counter { 
	display: block;
	font-size: 32px;
	font-weight: 700;
	color: #a2a2a2;
	line-height: 28px
}
.col-md-5{
    border: none;

}
.col-md-9 {
    flex: 0 0 auto;
    width: 84%;
}


.counter-box.colored p,
.counter-box.colored i,
.counter-box.colored .counter {
	color: #fff
}
#ImgAdd{
    width: 100%;
}
#ImgAdd2{
    width: 100%;
}
#ImgAdd3{
    width: 100%;
}
.Style-Video{
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}
.btn:hover{
  opacity: 0.7;
  transition: all 0.2s ease-in-out;
}

@media (max-width: 768px) {
    .Style-Video{
        width: 100%;
    }
    .Add-Video{
        max-width: 290px;
    }
    .modal-body img {
        max-width: 410px;
        max-height: 380px;
}
}
</style>
